export default __webpack_public_path__ + "static/4-19ab29b61f0479ac5e9c1740daf1100d.svg";